<template>
  <div class="ai_chat w-full mx-auto p-2 xl:p-4">
    <WordDictM class="lg:hidden" v-if="dickData" v-on:closeDict="dickData = null" :content="dickData.ductWord" />
    <div class="flex w-full">
      <TalkingIdol class="talkingIdol hidden xl:block" :selectedIdx="TalkingIdolIdx" />
      <div class="swiper_item flex-1">
        <div class="slider-banner relative">
          <div class="swiper" ref="mySwiper">
            <div v-show="isBegin" class="sm:px-6 lg:p-6">
              <div class="w-full relative flex">
                <div class="flex-1">
                  <Chat_header :isBegin="true" :selectedStep="0" v-on:reStart="reStart" />

                  <div class="chat-content bg-white p-3 w-full smooth-scroll" ref="chatContent">
                    <div v-if="chatObj.length > 0">
                      <div v-for="(item, index) in chatObj" :key="index">
                        <RobotDialogue :isSelectedType="false" :itemData="item" :isBegin="true" :selectedStep="selectedStep" class="mb-3" v-if="item.role === 'robot'" v-on:selectAnswer="selectAnswer" v-on:selectType="selectType" />
                        <SelfDialogue :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                        <RobotDialogue :isSelectedType="true" :selectedAns="selectedAns" :selectedAns2="selectedAns2" v-if="index === chatObj.length - 1 && (selectedAns && selectedAns2)" v-on:selectType="selectType" />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <a class="tips_btn block cursor-pointer lg:mt-20" @click="toggleTips">
                    <img src="@/assets/image/ai/tips_btn.png" alt="" class=" object-contain">
                  </a>
                  <testingToolsSWAL />
                </div>
              </div>
            </div>

            <div v-show="!isBegin" class="sm:px-6 lg:p-6">
              <div class="w-full relative flex">
                <div class="flex-1">
                  <Chat_header :isBegin="isBegin" :selectedStep="1" v-on:reStart="reStart" :selectedAns="selectedAns" :selectedAns2="selectedAns2" :recordArray="recordArray" :isDisabledInput="isDisabledInput" />
                  <div class="chat-content bg-white p-3 w-full smooth-scroll" ref="chatContent2">
                    <div v-if="conversationObj.length > 0">
                      <div v-for="(item, index) in conversationObj" :key="index">
                        <RobotDialogue :isBegin="isBegin" :chatHistory="chatHistory[index]" :itemIdx="index" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'robot'" :isDisabledInput="isDisabledInput" v-on:getItemTranslate="getItemTranslate" v-on:emitTalkIdolIdx="emitTalkIdolIdx" />
                        <SelfDialogue :chatHistory="chatHistory[index]" :theme="theme" :context="context" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'self'" :isDisabledInput="isDisabledInput" />
                      </div>
                    </div>
                  </div>

                  <div class="chat-button flex justify-center w-full items-center py-3">
                    <a class="mr-1 md:mr-2 cursor-pointer tooltip-outer w-auto h-auto hidden lg:inline-block" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult }">
                      <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="inline-block w-full h-auto object-contain" v-if="!isTranslateBtn">
                      <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="inline-block w-full h-auto object-contain" v-if="isTranslateBtn">
                      <span class="tooltiptext">中文輸入</span>
                    </a>
                    <a class="mr-1 md:mr-2 cursor-pointer tooltip-outer w-auto h-auto hidden lg:inline-block" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult }">
                      <img src="@/assets/image/ai/AI_A.png" alt="" class="inline-block w-full h-auto object-contain" v-if="!isAiSuggest">
                      <img src="@/assets/image/ai/AI_A_active.png" alt="" class="inline-block w-full h-auto object-contain" v-if="isAiSuggest">
                      <span class="tooltiptext">{{ $t('hover.ai_reply') }}</span>
                    </a>

                    <SpeechRecognition v-on:speechCountDown="speechCountDown" v-on:emitSpeechRecognition="emitSpeechRecognition" v-if="isOpenKeyboard" :isDisabledInput="isDisabledInput" />

                    <div class="chat-button-input flex items-center flex-1 p-1 md:p-2 bg-white" v-if="isOpenKeyboard">
                      <a v-if="!isSpeechRecognition" class="keyboard-btn notOpenKeyboard inline-block p-2 w-10 h-10">
                        <img src="@/assets/image/ai/notOpenKeyboard.png" alt="" class="inline-block object-contain">
                      </a>
                      <p class="mr-2 p-2 text-sm" v-if="isSpeechRecognition">{{ speechCount }}s</p>
                      <div class="flex-1">
                        <input ref="input3" v-if="$route.name === 'ChatAI'" @input="selfText = $event.target.value.replace(/[^\w\s',\uFF0C\u002E\u003F\uFF1A\u003A\/\-\!@]/g, '')" :disabled="remainPoints < 1 || isDisabledInput || !isAvailableInSchool" type="text" class="border-0 focus:outline-none block w-full" v-model="selfText" @keyup.enter="inputText3" :placeholder="!isDisabledInput ? $t('hover.placeholder') : '對話記錄僅供資料查看'">
                        <input ref="input3" v-if="$route.name === 'ChatAIJp'" :disabled="remainPoints < 1 || isDisabledInput || !isAvailableInSchool" type="text" class="border-0 focus:outline-none block w-full" v-model="selfText" @keyup.enter="inputText3" :placeholder="!isDisabledInput ? $t('hover.placeholder') : '對話記錄僅供資料查看'">
                      </div>
                      <a class="cursor-pointer p-2 tooltip-outer inline-block w-10 h-10" @click="inputText3()" :class="{ 'opacity-50': isDisabledInput }"><img src="@/assets/image/ai/submit_icon.png" alt="" class="">
                        <span class="tooltiptext object-contain">{{ $t('hover.sent') }}</span>
                      </a>
                    </div>
                  </div>
                  <div class="flex aiSuggestDialogue">
                    <div class="flex flex-col items-center">
                      <a class="mr-1 mb-3 md:mr-2 cursor-pointer tooltip-outer inline-block w-auto h-auto lg:hidden" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult }">
                        <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="inline-block w-full h-auto object-contain" v-if="!isTranslateBtn">
                        <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="inline-block w-full h-auto object-contain" v-if="isTranslateBtn">
                        <span class="tooltiptext">中文輸入</span>
                      </a>
                      <a class="mr-1 md:mr-2 cursor-pointer tooltip-outer inline-block w-auto h-auto lg:hidden" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult }">
                        <img src="@/assets/image/ai/AI_A.png" alt="" class="block w-full h-auto object-contain" v-if="!isAiSuggest">
                        <img src="@/assets/image/ai/AI_A_active.png" alt="" class="block w-full h-auto object-contain" v-if="isAiSuggest">
                        <span class="tooltiptext">{{ $t('hover.ai_reply') }}</span>
                      </a>
                    </div>
                    <AiSuggestDialogue :recordArray="recordArray" :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isAiSuggest" v-on:swal_failPopAPI="swal_failPopAPI" />
                    <TranslateDialogue :recordArray="recordArray" :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isTranslateBtn" v-on:swal_failPopAPI="swal_failPopAPI" />
                  </div>
                </div>
                <div>
                  <a class="tips_btn block cursor-pointer lg:mt-20" @click="toggleTips">
                    <img src="@/assets/image/ai/tips_btn.png" alt="" class=" object-contain">
                  </a>
                  <testingToolsSWAL />
                </div>
              </div>
            </div>
          </div>
          <a v-if="(ai_sid || $route.query.sid) && queryS === 'elab'" class="m:px-6 lg:p-6 inline-block gept_main_bg4 text-white px-8 py-2 rounded-full mx-auto cursor-pointer font-bold hover:opacity-75"  @click="window.close()">關閉視窗</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import api from '@/api'
import Chat_header from '@/components/AiHelper/chat/chat_header'
import RobotDialogue from '@/components/AiHelper/chat/robotDialogue'
import SelfDialogue from '@/components/AiHelper/chat/selfDialogue'
import AiSuggestDialogue from '@/components/AiHelper/chat/aiSuggestDialogue'
import TranslateDialogue from '@/components/AiHelper/chat/translateDialogue'
import SpeechRecognition from '@/components/AiHelper/chat/SpeechRecognition'
import allJs from '@/components/all.js'
import Bus from '@/components/bus.js'
import WordDictM from '@/components/AiHelper/WordDictM'
import TalkingIdol from '@/components/AiHelper/chat/TalkingIdol'
import testingToolsSWAL from '@/components/AiHelper/chat/testingToolsSWAL'

export default {
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  name: 'chat_ai',
  components: {
    RobotDialogue,
    SelfDialogue,
    AiSuggestDialogue,
    TranslateDialogue,
    Chat_header,
    SpeechRecognition,
    WordDictM,
    TalkingIdol,
    testingToolsSWAL
  },
  mixins: [
    allJs
  ],
  data() {
    return {
      pageTitle: '生活情境主題',
      chatJSon: null,
      selectedStep: 0,
      isOpenKeyboard: true,
      isTips: false,
      isDictionary: false,
      isBegin: true,
      isAiSuggest: false,
      isTranslateBtn: false,

      isDisabledInput: false,

      recorder: null,
      playTime: 0,
      timer: null,
      src: null,
      isRecorder: false,

      session_id: null,

      selfText: '',

      selectedAns: null,
      selectedAns2: null,

      chatObj: [],

      follow_upObj: [],

      conversationObj: [],

      element2OffsetHeight: null,

      speechCount: null,
      isSpeechRecognition: false,

      carousel_left: 0,

      lastChatResult: null,

      isGettingChatsCreate: false,

      chatHistory: [],

      audio_id: '',

      playbackRate: 1,

      dickData: null,

      prompt_id: null,

      recordScene: null,

      schoolData: null,
      TalkingIdolIdx: 0,

      intervalId: null
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'lang',
      'remainPoints',
      'ai_sid',
      'ai_uuid'
    ]),

    theme () {
      let self = this
      if (self.schoolData) {
        return self.schoolData.theme
      } else {
        if ((self.selectedAns && self.selectedAns2 && self.selectedStep === 0) || (self.selectedAns && self.selectedAns2 && self.selectedStep === 1)) {
          return self.selectedAns2.theme
        } else if (self.$route.name === 'viewChat' && self.recordScene) {
          return self.recordScene.theme
        }
        return ''
      }
    },

    context () {
      let self = this
      if (self.schoolData) {
        return self.schoolData.context
      } else {
        if ((self.selectedAns && self.selectedAns2 && self.selectedStep === 0) || (self.selectedAns && self.selectedAns2 && self.selectedStep === 1)) {
          return self.selectedAns2.context
        } else if (self.$route.name === 'viewChat' && self.recordScene) {
          return self.recordScene.context
        }
        return ''
      }
    },

    context2 () {
      let self = this
      if (self.schoolData) {
        return self.schoolData.context2
      } else {
        if (self.selectedAns && self.selectedAns2 && self.selectedStep === 0) {
          return self.selectedAns2.context2
        } else if (self.selectedAns && self.selectedAns2 && self.selectedStep === 1) {
          return self.selectedAns2.context2
        }
        return ''
      }
    },

    bookName () {
      let self = this

      if (self.$route.params.promptId === 'e95542ea-37d6-4ccd-86a1-cf2a0e66c0f1') {
        return 'ABC會話主題'
      } else if (self.$route.params.promptId === '46c0311c-00e5-412b-aac8-4b95bc48105b') {
        return 'LIVE會話主題'
      } else if (self.$route.params.promptId === '80762ac0-0de5-4877-9779-3d5a0d4be187') {
        return 'ALL+會話主題'
      }

      return '生活情境主題'
    },

    recordArray () {
      let self = this

      let arr = {
        'conversation_id': self.session_id ? self.session_id : '',
        'book': self.bookName,
        'subject': self.selectedAns ? self.selectedAns.name : '',
        'unit': self.selectedAns2 ? self.selectedAns2.name : '',
        'used_points': 1
      }
      return arr
    },

    isAvailableInSchool () {
      const uuidExpiredTime = this.$route.query.expired_time || localStorage.getItem('uuid_expired_time')
      if (uuidExpiredTime) {
        const expiredTime = String(uuidExpiredTime)
        const eventDate = moment(expiredTime)
        if (!eventDate.isValid()) {
          return false
        }

        // Date-only values are valid through the end of that calendar day.
        const expireAt = /^\d{4}-\d{2}-\d{2}$/.test(expiredTime) ? eventDate.endOf('day') : eventDate
        return moment().isSameOrBefore(expireAt)
      }
      return true
    },

    queryS () {
      if (this.$route.query.s) {
        return this.$route.query.s
      } else if (localStorage.getItem('s')) {
        return localStorage.getItem('s')
      }
      return null
    }
  },
  watch: {
    'conversationObj': {
      handler (oldVal, newVal) {
        let self = this
        if (newVal !== oldVal) {
          self.scrollToBottom()
        }
      },
      deep: true,
      immediate: true
    },
    '$route.params.promptId': {
      handler (oldVal, newVal) {
        if (newVal !== oldVal) {
          this.reStart()
        }
      },
      deep: true
    },
    'authorized': {
      handler (newVal, oldVal) {
        if (oldVal !== newVal && newVal) {
          if (this.$route.name === 'viewChat') {
            this.initViewSetting()
          } else if (this.ai_uuid || this.$route.query.uuid) {
            this.getSchoolData()
          }
        }
      },
      immediate: true
    }
  },
  created () {
    this.startCheckingAuth()
  },
  mounted () {
    this.getBus()
  },
  updated () {
    this.scrollToBottom()
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    ...mapActions({}),
    startCheckingAuth () {
      this.intervalId = setInterval(() => {
        this.$store.dispatch('isLoading', true)
        if (this.authorized) {
          clearInterval(this.intervalId)
          this.$store.dispatch('isLoading', false)
          this.initFunc()
        }
      }, 1000)
    },
    initFunc () {
      this.$route.name !== 'ChatAI' ? this.$store.dispatch('setAccent', 'en-EN') : null

      if ((this.$route.name === 'ChatAI' || this.$route.name === 'ChatAIJp') && (!this.ai_uuid && !this.$route.query.uuid)) {
        if (this.queryS === 'elab') {
          this.fuckAIETA()
        } else {
          this.getCategories()
        }
      }
    },
    // elab
    fuckAIETA () {
      let promptId = this.$route.params.promptId

      if (promptId) {
        let path = `/categories/${promptId}`
        api.get(path)
          .then((res) => {
            this.schoolData = res.data.data
            this.prompt_id = res.data.prompt_id

            this.isBegin = false

            this.$nextTick(() => {
              this.selectedStep = 1
              this.toSlide(1)

              this.chatsCreate()
            })
          })
          .catch(() => {})
      }
    },
    // school
    getSchoolData () {
      let uuid = this.$route.query.uuid || this.ai_uuid || null

      if (uuid) {
        let path = `/categories/${uuid}`
        api.get(path)
          .then((res) => {
            this.schoolData = res.data.data
            this.prompt_id = res.data.prompt_id

            this.isBegin = false

            this.$nextTick(() => {
              this.selectedStep = 1
              this.toSlide(1)

              this.chatsCreate()
            })
          })
          .catch(() => {})
      }
    },

    // view
    async initViewSetting () {
      let self = this

      self.$route.query.conversation_id ? self.session_id = self.$route.query.conversation_id : null

      await self.getHistory()

      self.isDisabledInput = true
      self.isBegin = false

      self.$nextTick(() => {
        self.selectedStep = 1
        self.toSlide(1)
      })
    },

    async initConversationObj (records) {
      let self = this

      self.$route.name === 'viewChat' ? self.$store.dispatch('isLoading', true) : null
      let array = []
      for (let item of records) {
        if (item.role === 'assistant') {
          array.push({
            isLoading: false,
            role: 'robot',
            text: item.content,
            translate: self.theme && self.context && self.$route.name !== 'viewChat' ? await self.get_Translate_Dialog(self.theme, self.context, item.content) : '',
            audio: item.audio,
            ttsUrl: ''
          })
        }
        if (item.role === 'user') {
          array.push({
            role: 'self',
            text: item.content
          })
        }
      }

      self.conversationObj = array
      self.$route.name === 'viewChat' ? self.$store.dispatch('isLoading', false) : null
    },

    // chat
    getBus () {
      let self = this
      Bus.$on('getDickData', (data) => {
        self.dickData = data
      })
      Bus.$on('restartData', () => {
        self.$data.selfText = self.$options.data().selfText
      })
    },

    getCategories () {
      let self = this

      let promptId = self.$route.params.promptId

      let path = `/categories/${promptId}`

      let obj = { role: 'robot', text: '請選擇主題，來場零壓力的互動對話練習吧！', text_en: 'Select a topic and enjoy stress-free conversation practice!', options: null, isLoading: true }
      self.chatObj.push(obj)

      api.get(path)
        .then((res) => {
          if (self.$route.name === 'ChatAIJp') {
            self.prompt_id = '018970f3-cabd-4925-b697-bed8e37b13be'
          } else {
            self.prompt_id = res.data.prompt_id
          }
          self.chatJSon = res.data.data

          let index = self.chatObj.findIndex(x => x.isLoading === true)

          self.chatObj[index].isLoading = false
          self.chatObj[index].options = res.data.data
        })
        .catch(() => {
          self.chatObj.pop()
        })
    },

    emitSpeechRecognition(emitSpeechRecognition) {
      let self = this

      if (emitSpeechRecognition) {
        self.selfText = self.selfText + emitSpeechRecognition.result

        self.audio_id = emitSpeechRecognition.id

        self.$refs.input3.focus()
      }
    },

    generateSentence () {
      // 實用句
      let self = this

      let path = `/ai/generate/43da810e-a5c8-45b1-a776-df25518532d5`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      self.follow_upObj.push(obj)

      api.post(path, {
        theme: self.theme,
        context: self.context
      })
        .then((res) => {
          self.setDataWithFollow(res.data.result)
          self.$nextTick(() => {
            self.scrollToBottom()
          })
        })
        .catch(() => {})
    },

    async chatsCreate () {
      // 會話開始
      if (!this.prompt_id || this.isGettingChatsCreate || this.conversationObj.length > 0) return
      let self = this

      let path = `/ai/generate/${this.prompt_id}`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      this.conversationObj.push(obj)
      this.isGettingChatsCreate = true

      this.isDisabledInput = true

      let body = {
        theme: this.theme,
        context: this.context
      }

      if (!this.ai_sid && !this.ai_uuid && !self.$route.query.uuid && !self.$route.query.sid) {
        body.chat_name = `${self.$route.name === 'ChatAIJp' ? 'AI日語口說小助教' : 'AI英語口說小助教'}(${self.pageTitle} /${self.selectedAns.name}/${self.selectedAns2.name})`
      }

      await api.post(path, body)
        .then((res) => {
          this.session_id = res.data.session

          this.setDataWithPractice(res.data.result)

          this.isGettingChatsCreate = false

          this.isDisabledInput = false
        })
        .then(() => {
          this.$data.selfText = self.$options.data().selfText
        })
        .catch((error) => {
          this.conversationObj.pop()
          this.isGettingChatsCreate = false
          this.isDisabledInput = false

          this.swal_failPopAPI(error.response)
        })
    },

    chatsContinue (text) {
      if (!this.prompt_id) return
      // 繼續對話
      let self = this

      let path = `/ai/generate/${self.prompt_id}?session=${self.session_id}`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      self.conversationObj.push(obj)

      self.isDisabledInput = true

      api.post(path, {
        content: text,
        audio: self.audio_id
      })
        .then((res) => {
          self.setDataWithPractice(res.data.result)

          self.audio_id = ''

          self.$store.dispatch('writeRecord', self.recordArray)

          self.isDisabledInput = false

          self.$nextTick(() => {
            self.ai_sid ? self.$store.dispatch('saveRecord', self.recordArray) : null
          })
        })
        .then(() => {
          self.$data.selfText = self.$options.data().selfText
        })
        .catch((error) => {
          self.conversationObj.pop()
          self.isDisabledInput = false

          if (error.response && error.response.status === 400) {
            self.swal_failPopAPI(error.response)
          }
        })
    },

    getHistory () {
      let self = this

      let path = `/ai/chats/${self.session_id}`

      self.$route.name === 'viewChat' ? self.$store.dispatch('isLoading', true) : null

      api.get(path)
        .then((res) => {
          self.$store.dispatch('isLoading', false)
          self.chatHistory = res.data.records

          if (res.data.theme && res.data.context) {
            self.recordScene = {
              theme: res.data.theme,
              context: res.data.context
            }
          }

          self.$route.name === 'viewChat' ? self.initConversationObj(res.data.records) : null
        })
        .catch(() => {
          self.$store.dispatch('isLoading', false)
        })
    },

    async setDataWithFollow (result) {
      let self = this

      let index = self.follow_upObj.findIndex(x => x.isLoading === true)

      self.follow_upObj[index].isLoading = false
      self.follow_upObj[index].text = result
      self.follow_upObj[index].translate = null
    },

    async setDataWithPractice (result) {
      let self = this

      let index = self.conversationObj.findIndex(x => x.isLoading === true)

      self.conversationObj[index].isLoading = false
      self.conversationObj[index].text = result
      self.conversationObj[index].translate = await self.get_Translate_Dialog(self.theme, self.context, result)

      self.lastChatResult = result

      self.$nextTick(() => {
        self.scrollToBottom()
        self.getHistory()

        self.$store.dispatch('getRemainPoints')
      })
    },

    reStart () {
      this.isAiSuggest = false
      this.isTranslateBtn = false
      this.chatObj = this.$options.data().chatObj
      this.follow_upObj = this.$options.data().follow_upObj
      this.conversationObj = this.$options.data().conversationObj

      this.$forceUpdate()

      this.initFunc()
      if (!this.ai_uuid) {
        this.isBegin = true
        this.selectedStep = 0

        this.selectedAns = null
        this.selectedAns2 = null
      }
    },

    scrollToBottom () {
      let self = this
      const element = self.$refs.chatContent
      const element1 = self.$refs.chatContent1
      const element2 = self.$refs.chatContent2

      if (self.$refs.chatContent && element.scrollHeight > element.offsetHeight) {
        element.scrollTop = element.scrollHeight
      }
      if (self.$refs.chatContent1 && element1.scrollHeight > element1.offsetHeight) {
        element1.scrollTop = element1.scrollHeight
        self.$nextTick(() => {
          element1.scrollTop = element1.scrollHeight
        })
      }
      if (self.$refs.chatContent2 && element2.scrollHeight > element2.offsetHeight) {
        element2.scrollTop = element2.scrollHeight
        self.$nextTick(() => {
          element2.scrollTop = element2.scrollHeight
        })
      }
    },

    selectAnswer (selectAnswer) {
      let self = this
      if (selectAnswer.name !== '我有其他想法') {
        if (selectAnswer.items) {
          self.selectedAns = selectAnswer

          self.chatObj.push({ role: 'self', text: selectAnswer.name, text_en: selectAnswer.name_en })
          self.chatObj.push({ role: 'robot', text: `你想在${selectAnswer.name}做什麼呢？`, text_en: `What would you like to do?`, options: selectAnswer.items })

          if (self.selectedAns2) {
            self.selectedAns2 = null
          }
        } else {
          if (selectAnswer.pre_name !== self.selectedAns.name) {
            let index = self.chatJSon.findIndex(x => x.name === selectAnswer.pre_name)
            self.selectedAns = self.chatJSon[index]
          }
          self.selectedAns2 = selectAnswer

          self.chatObj.push({ role: 'self', text: selectAnswer.name, text_en: selectAnswer.name_en })
        }
      } else {
        self.$refs.input1.focus()
      }
    },

    inputText () {
      let self = this

      if (self.selfText) {
        if (self.selectedAns.items) { // Fixed undefined reference to selectAnswer
          self.selectedAns = {
            name: self.selfText,
            name_en: self.selfText,
            theme_practical: self.selfText,
            theme_chat: self.selfText
          }

          self.chatObj.push({ role: 'self', text: self.selectedAns.name })
          self.chatObj.push({ role: 'robot', text: `你想在${self.selectedAns.name}做什麼呢？`, text_en: `你想在${self.selectedAns.name}做什麼呢？`, options: self.selectedAns.items })

          if (self.selectedAns2) {
            self.selectedAns2 = null
          }
        } else {
          self.selectedAns2 = {
            name: self.selfText,
            name_en: self.selfText,
            theme_practical2: self.selfText,
            theme_chat2: self.selfText,
            context_practical: self.selfText,
            context_chat: self.selfText
          }

          self.chatObj.push({ role: 'self', text: self.selectedAns.name })
        }
      }
    },

    inputText2 () {},

    inputText3 () {
      let self = this
      if (self.selfText.trim().length > 0 && self.remainPoints > 0 && !self.isDisabledInput && self.isAvailableInSchool) {
        self.conversationObj.push({ role: 'self', text: self.selfText })

        self.chatsContinue(self.selfText)

        self.$data.selfText = self.$options.data().selfText

        self.isAiSuggest = false
      }

      if (self.remainPoints < 1) {
        self.swal_failPopPoints('點數不足')
      }

      if (!self.isAvailableInSchool) {
        self.swal_failPopPoints('使用點數不足或時間過期')
      }
    },

    toSlide (i) {
      let self = this
      self.selectedStep = i
    },

    selectType (selectType) {
      let self = this
      if (self.remainPoints > 0) {
        const myName1 = () => {
          return new Promise(async (resolve) => {
            let isStart = await self.swal_startCheck()

            if (isStart) {
              self.isBegin = false
              resolve('isBegin')
            }
          })
        }

        Promise.race([myName1()])
          .then(() => {
            if (selectType === 'record') {
              self.selectedStep = 0
              self.toSlide(0)

              self.generateSentence()
            } else if (selectType === 'practice') {
              self.selectedStep = 1
              self.toSlide(1)

              !self.isGettingChatsCreate ? self.chatsCreate() : null
            }
          })
      } else {
        self.swal_failPopPoints('點數不足')
      }
    },

    onPageChange(currentPage) {
      if (currentPage === 0) {
        if (this.follow_upObj.length < 1 && this.conversationObj.length > 0) {
          this.generateSentence()
        }
      } else {
        if (this.follow_upObj.length > 0 && this.conversationObj.length < 1) {
          this.chatsCreate()
        }
      }
    },

    speechCountDown (speechCountDown) {
      this.isSpeechRecognition = speechCountDown.isSpeechRecognition
      this.speechCount = speechCountDown.count
    },

    toggleTranslateBtn () {
      if (this.lastChatResult && this.remainPoints > 0 && this.isAvailableInSchool) {
        this.isTranslateBtn = !this.isTranslateBtn
        this.isAiSuggest = false
      } else if (this.remainPoints < 1) {
        this.isTranslateBtn = false
        this.swal_failPopPoints('點數不足')
      } else if (!this.isAvailableInSchool) {
        this.isTranslateBtn = false
        this.swal_failPopPoints('使用點數不足或時間過期')
      }
    },

    toggleAISuggest () {
      if (this.lastChatResult && this.remainPoints > 0 && this.isAvailableInSchool) {
        this.isAiSuggest = !this.isAiSuggest
        this.isTranslateBtn = false
      } else if (this.remainPoints < 1) {
        this.isAiSuggest = false
        this.swal_failPopPoints('點數不足')
      } else if (!this.isAvailableInSchool) {
        this.isAiSuggest = false
        this.swal_failPopPoints('使用點數不足或時間過期')
      }
    },

    swal_startCheck () {
      let self = this
      return self.$swal({
        html: `<p class="mb-2">目前總點數：<span style="color: #F30000;">${self.remainPoints}</span> 點</p><p>當進行 AI 口說練習，每次送出後隨即扣除 1 點。</p>`,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: `我知道了`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-center items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      }).then((result) => {
        if (result.isConfirmed === true) {
          return true
        }
      })
    },

    swal_failPopPoints (text) {
      let self = this
      let defaultTitle = text ? `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
      self.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-center items-center',
          closeButton: '',
          htmlContainer: 'save_check my-4 text-xl',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    swal_failPopUp (text) {
      let self = this
      let defaultTitle = text ? `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
      self.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    swal_failPopAPI (error) {
      console.log(error.data.msg)
      let self = this
      let text = error?.data?.msg ? error.data.msg : '請重新輸入'
      self.$swal({
        html: `<p>${text}</p>`,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: `我知道了`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-center items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      }).then((result) => {
        if (result) {
          self.isDisabledInput = false
        }
      })
    },

    async getItemTranslate (getItemTranslate) {
      let self = this
      self.conversationObj[getItemTranslate].translate = await self.get_Translate_Dialog(self.theme, self.context, self.conversationObj[getItemTranslate].text)
    },

    emitTalkIdolIdx (emitTalkIdolIdx) {
      this.TalkingIdolIdx = emitTalkIdolIdx
    },

    toggleTips () {
      let self = this
      const htmlText = `
        <h6 id="swal-points" class="mb-1 font-bold text-lg">目前總點數：
          <span class="text-red-main-ai">${this.remainPoints}</span> 點
        </h6>
        <h6 class="font-bold text-lg mb-3">口說練習每次扣除：<span class="text-red-main-ai">1</span> 點</h6>
        <h6 class="font-bold text-lg">操作說明：</h6>
        <p class="mb-2">1. 點<img src="${require('@/assets/image/ai/mic_C.png')}" class="inline-block icon-img mx-1">說出回應的句子，再點
          <img src="${require('@/assets/image/ai/submit_icon.png')}" class="inline-block icon-img mx-1">，送出後隨即扣點。</p>
        <p class="mb-2">2. 點<img src="${require('@/assets/image/ai/AI_A.png')}" class="inline-block icon-img mx-1">參考 AI 回應內容，並練習說說看。</p>
        <p class="mb-2">3. 點<img src="${require('@/assets/image/ai/translate_btn_off.png')}" class="inline-block icon-img mx-1">輸入想翻譯的中文。</p>
        <p class="mb-2">4. 點<img src="${require('@/assets/image/ai/btn_AItalk_voice.png')}" class="inline-block icon-img mx-1">聆聽自己的錄音。</p>
        <p class="mb-2">5. 點<img src="${require('@/assets/image/ai/btn_AItalk_correct.png')}" class="inline-block icon-img mx-1">觀看 AI 反饋建議，讓自己下次說得更好。</p>
        <p class="mb-2">6. 若 AI 回應不符預期，請修改文字內容或點擊重新整理。</p>
      `
      return self.$swal({
        html: htmlText,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: `關閉`,
        title: '溫馨小提醒',
        position: window.innerWidth < 768 ? 'top' : 'center',
        customClass: {
          title: 'text-white text-xl',
          popup: 'p-0',
          header: 'justify-center items-center swal_tips',
          htmlContainer: 'my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-deny'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-banner {
  .swiper-button-next {
    right: -68px;
    background-size: contain;
    background-size: 35px 35px;
    background-position: center;
    width: 68px;
    height: 80%;
    transform: translateY(-50%);
    background: linear-gradient(85.19deg, #D4D5E1 3.73%, #FFFFFF 47.56%);
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: '→ 對話 練習';
      color: #5A5D9B;
      font-weight: 700;
    }
  }
  .swiper-button-prev {
    left: -68px;
    background-size: contain;
    background-size: 35px 35px;
    background-position: center;
    width: 68px;
    height: 80%;
    transform: translateY(-50%);
    background: linear-gradient(272.05deg, #D4D5E1 1.95%, #FFFFFF 42.8%);
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: '← 跟讀 練習';
      color: #5A5D9B;
      font-weight: 700;
    }
  }
}

.ai_chat {
  min-height: calc(100vh - 108px);
  .swiper_item {
    min-height: 600px;
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 8);
      padding: 0.5rem;
    }
  }
  .swiper_rule {
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 4);
      padding: 0.5rem;
    }
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .VueCarousel-navigation-next {
    width: 68px;
    height: 538px;
    background: linear-gradient(272.05deg, #D4D5E1 1.95%, #FFFFFF 42.8%);
  }
  .follow-btn {
    a {
      height: 3.5em;
      &:hover {
        text-decoration: none !important;
      }
    }
  }
}

.tips-btns {
  top: 0%;
  right: 0;
  padding-top: 82px;
}

.chat-content {
  height: calc(65vh);
  overflow-y: scroll;
  overflow-x: hidden;
  @media (max-width: 769px) {
    height: calc(70vh);
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .tips-content {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .tips-shadow-bg {
      width: 8%;
      background:rgba(0, 0, 0, 0.7);
    }
    .tips-right {
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
}

.chat-button-input {
  border-radius: 53px;
  img {
    height: 28px;
    width: auto;
  }
}

.keyboard-btn {
  img {
    height: 25px;
    width: auto;
  }
}

.notOpenKeyboard {}

.openKeyboard {
  img {
    height: 54px;
    width: auto;
  }
}

.microphone-btn {
  background-color: #5A5D9B;
  padding: .8rem 6.5rem;
  border-radius: 53px;
  img {
    height: 26px;
    width: auto;
  }
}

.aiSuggestDialogue {
  min-height: 52px;
  @media (max-width: 1024px) {
    min-height: 172px;
  }
}
</style>
